"use strict";

module.exports = /*@ngInject*/function ($resource, ConfigService) {
  var _ConfigService$getCon = ConfigService.getConfig(),
    INSPECT_URL = _ConfigService$getCon.INSPECT_URL;
  var service = $resource("".concat(INSPECT_URL, "/api/profile"), {}, {
    getSuperUsers: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/service-desk/superuser/list"),
      isArray: true
    },
    addSuperUser: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/service-desk/superuser/add")
    },
    deleteSuperUser: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/service-desk/superuser/:userId/delete")
    }
  });
  return service;
};